// extracted by mini-css-extract-plugin
export default {"row":"Thead_row__Ddz8q","cell":"Thead_cell__nIzV9"};